import { api } from "../../services/Api.js";
//import Vue from 'vue';

export function add_chat_message({ commit, state }, payload ){

    // adding token
    payload.token=state.appSettings.token
    
    commit('ADD_CHAT_MESSAGE', {store_key:payload.store_key,message:payload.message, datetime:payload.datetime});
   
    // get active school
    var school = state.user_schools.find(school => school.active === 1);
    
    
   

    // return chainable promise
    
    return api
    .post(school,"add_chat_message.php",payload)
    .then( () =>{
      //console.log("***** chat message added ******")
      //console.dir(result.data);
      // as this is posted by me, we can directly add it to the fetched messages
      
    })
    .catch( () => {

      // not show error on failure 
      //Vue.$toaster.toast("[error: action add_chat_message]" + error);
     
    })
   

}